module.exports = __webpack_public_path__ + "static/media/landing-mngr.0b891806.svg";